import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "subscription-confirm-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Please make sure all of the service details are correct before you confirm and book your appointment. Once your service details are confirmed we will provide you with next steps. ")
], -1)
const _hoisted_3 = { class: "col-md-9" }
const _hoisted_4 = { class: "estimate-details" }
const _hoisted_5 = { class: "estimate-details-money font-weight-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_7 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "estimate-details-address" }
const _hoisted_10 = { class: "estimate-details-address" }
const _hoisted_11 = { class: "estimate-details-address" }
const _hoisted_12 = {
  key: 1,
  class: "location-mobile estimate-details-address"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "col-md-3 text-right" }
const _hoisted_15 = { class: "col-sm-12 location-hours" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pb-4" }, "This service center provides services in the order the vehicle arrives.")
], -1)
const _hoisted_17 = { class: "col-md-9" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "appt-slots-container"
}
const _hoisted_20 = { class: "appt-slots-labels" }
const _hoisted_21 = { class: "appt-slots-values" }
const _hoisted_22 = { class: "col-md-3 text-right" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "pb-4" }, " Please provide the address where the mobile mechanic will service your vehicle. The location you specify must allow auto service to be performed onsite. ", -1)
const _hoisted_24 = { class: "mobile-fixed-actions" }
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertPane = _resolveComponent("AlertPane")!
  const _component_confirmation_detail_row = _resolveComponent("confirmation-detail-row")!
  const _component_location_hours = _resolveComponent("location-hours")!
  const _component_base_address_inputs = _resolveComponent("base-address-inputs")!
  const _component_confirmation_details_box = _resolveComponent("confirmation-details-box")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_AlertPane, {
      show: !!_ctx.alert.message,
      variant: 'danger'
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.alert.message), 1)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_confirmation_details_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_confirmation_detail_row, null, {
          label: _withCtx(() => [
            _createTextVNode("Services:")
          ]),
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceNames, (service) => {
              return (_openBlock(), _createElementBlock("p", { key: service }, _toDisplayString(service), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_confirmation_detail_row, null, {
          label: _withCtx(() => [
            _createTextVNode("Vehicle:")
          ]),
          content: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.vehicleInfo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_confirmation_detail_row, { "content-class": "row" }, {
          label: _withCtx(() => [
            _createTextVNode("Estimate:")
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  (_ctx.hasSubscription)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(_ctx.monetize(_ctx.offer.totalPriceInDollars, 'dollars')), 1))
                    : (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(_ctx.monetize(_ctx.offer.totalBeforeTaxWithPlatformDiscounts.cents, 'cents')), 1)),
                  _hoisted_8,
                  _createElementVNode("a", {
                    class: "font-weight-normal mt-1",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showOfferDetailModal && _ctx.showOfferDetailModal(...args)))
                  }, " See estimate details ")
                ]),
                _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.offer.location.name), 1),
                (!_ctx.isMobileMechanic)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.offer.location.address), 1),
                      _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.offer.location.phoneNumber), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createElementVNode("img", {
                        src: _ctx.asset(require('@/assets/images/shipping-fast.svg'))
                      }, null, 8, _hoisted_13),
                      _createTextVNode(" Mobile mechanic. We come to you! ")
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                href: "#",
                class: "font-weight-normal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.returnToEstimates && _ctx.returnToEstimates(...args)), ["prevent"]))
              }, "Change")
            ])
          ]),
          _: 1
        }),
        (_ctx.offer.location.firstComeFirstServe)
          ? (_openBlock(), _createBlock(_component_confirmation_detail_row, {
              key: 0,
              "content-class": "row"
            }, {
              label: _withCtx(() => [
                _createTextVNode("Shop Hours:")
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_location_hours, {
                    "location-hours": _ctx.offer.location.hours
                  }, null, 8, ["location-hours"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.offer.location.firstComeFirstServe)
          ? (_openBlock(), _createBlock(_component_confirmation_detail_row, {
              key: 1,
              "content-class": "row",
              bottom: !_ctx.isMobileMechanic
            }, {
              label: _withCtx(() => [
                _createTextVNode("Notes:")
              ]),
              content: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["bottom"]))
          : (_openBlock(), _createBlock(_component_confirmation_detail_row, {
              key: 2,
              "content-class": "row",
              bottom: !_ctx.isMobileMechanic
            }, {
              label: _withCtx(() => [
                _createTextVNode("Appointment:")
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.appointmentSlots.length === 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.appointmentSlots[0].fullSlotTitle), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointmentSlots, (apptSlot, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: `appt-slot-label-${index}`
                            }, _toDisplayString(_ctx.capitalize(_ctx.ordinalize(index + 1))) + " preference: ", 1))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointmentSlots, (apptSlot, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: `appt-slot-value-${index}`
                            }, _toDisplayString(apptSlot.fullSlotTitle), 1))
                          }), 128))
                        ])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "font-weight-normal",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
                  }, "Change")
                ])
              ]),
              _: 1
            }, 8, ["bottom"])),
        (_ctx.isMobileMechanic)
          ? (_openBlock(), _createBlock(_component_confirmation_detail_row, {
              key: 3,
              bottom: _ctx.isMobileMechanic
            }, {
              label: _withCtx(() => [
                _createTextVNode("Service Address:")
              ]),
              content: _withCtx(() => [
                _hoisted_23,
                _createElementVNode("p", null, [
                  _createVNode(_component_base_address_inputs, {
                    "default-country": "US",
                    onAddressUpdated: _ctx.updateServiceAddress
                  }, null, 8, ["onAddressUpdated"])
                ])
              ]),
              _: 1
            }, 8, ["bottom"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        class: "btn btn-tertiary cancel-button",
        type: "button",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
      }, "Cancel"),
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        disabled: _ctx.loading || !_ctx.serviceAddressValid,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.acceptOffer && _ctx.acceptOffer(...args)))
      }, " Confirm & book ", 8, _hoisted_25)
    ])
  ]))
}